//configure the fixed footer
Y.use('node', 'event-resize', 'event-custom-base', 'gallery-debounce', function (Y) {
    'use strict';

    const rz = {
        body: Y.one('body'),
        header: Y.one('header'),
        pageHeader: Y.one('.page-header'),
        offset: Y.one('#offset'),
        applyPadding: function () {
            const o = this;
            let p = 10;
            if (o.header || o.pageHeader) {
                if (o.header) {
                    p += o.header.get('clientHeight');
                }
                if (o.pageHeader) {
                    p += o.pageHeader.get('clientHeight');
                }
                o.offset.setStyle('height', p + 'px');
            }
        },
        setFixedHeader: Y.debounce(250, function () {
            this.body.addClass('fixed-head ');
            //setup initial padding
            this.applyPadding();
            if (this.pageHeader) {
                this.pageHeader.addClass('usp-fx-left');
            }
        }),
        setScrolled: function () {
            if (this.pageHeader) {
                if (window.scrollY > 20) {
                    this.pageHeader.addClass('scrolled');
                } else {
                    this.pageHeader.removeClass('scrolled');
                }
            }
        }
    };
    //listen for custom event to apply padding
    Y.on('header:resize', rz.setFixedHeader, rz);

    //listen for window resize
    Y.on('windowresize', rz.setFixedHeader, null, rz);

    Y.on('scroll', rz.setScrolled, null, rz);

    //set the header as fixed
    Y.on('domready', rz.setFixedHeader, rz);
});
